import React, { Component } from 'react';
import withRouter from '../../config/WithRouter';
import './styles/cardheader.scss';
import imgfSelectLeft from './img/select-left.svg';

class CardHeader extends Component {
  /* =========================
   * BOTÕES EXTRAS
   * ========================= */
  renderButtons() {
    const { aButtons } = this.props;
    if (typeof aButtons === 'undefined') {
      return '';
    }

    return Object.keys(aButtons).map(cKey => aButtons[cKey]);
  }

  /* =========================
   * STACK DE NAVEGAÇÃO (ROTAS PLANAS)
   * ========================= */

  readStack = () => {
    try {
      const raw = sessionStorage.getItem('folderNavStack');
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  writeStack = stack => {
    sessionStorage.setItem('folderNavStack', JSON.stringify(stack));
  };

  readFolderReturnTo = () => {
    try {
      return sessionStorage.getItem('folderReturnTo') || '';
    } catch {
      return '';
    }
  };
  
  writeFolderReturnTo = (path) => {
    try {
      if (path && path.startsWith('/folder_old')) {
        sessionStorage.setItem('folderReturnTo', path);
      }
    } catch {}
  };

  
  pushPrevPathIfNeeded = (prevPath, currPath) => {
    if (!prevPath || !currPath) return;
    if (prevPath === currPath) return;
  

    if (!prevPath.startsWith('/folder_old')) return;
  
    const stack = this.readStack();
    const last = stack[stack.length - 1];
  
    // evita empilhar repetido
    if (last !== prevPath) {
      stack.push(prevPath);
  
      // limite de segurança
      if (stack.length > 50) stack.shift();
  
      this.writeStack(stack);
    }
  };
  

  popAndGoBack = navigate => {
    const currPath = this.props?.router?.location?.pathname || '';
  
    // ✅ Se estou em documento, volta para a última pasta salva
    if (currPath.startsWith('/document')) {
      const folderReturnTo = this.readFolderReturnTo();
      if (folderReturnTo) {
        navigate(folderReturnTo, {
          replace: true,
          state: { forceReload: Date.now(), __skipFolderStackPush: true },
        });
        return;
      }
    }
  
    // fallback: comportamento atual do stack
    const stack = this.readStack();
    const prev = stack.pop();
    this.writeStack(stack);
  
    const target = prev || '/folder_old';
  
    navigate(target, {
      replace: true,
      state: {
        forceReload: Date.now(),
        __skipFolderStackPush: true,
      },
    });
  };
  
  /* =========================
   * CICLO DE VIDA
   * ========================= */

  componentDidMount() {
    // garante que o stack exista
    this.writeStack(this.readStack());
  }

  componentDidUpdate(prevProps) {
    const prevPath = prevProps?.router?.location?.pathname;
    const currPath = this.props?.router?.location?.pathname;
  
    // se estou em /folder_old/... grava como "última pasta"
    if (currPath && currPath.startsWith('/folder_old')) {
      this.writeFolderReturnTo(currPath);
    }
  
    const shouldSkipPush = !!this.props?.router?.location?.state?.__skipFolderStackPush;
    if (shouldSkipPush) return;
  
    if (prevPath !== currPath) {
      this.pushPrevPathIfNeeded(prevPath, currPath);
    }
  }
  
  /* =========================
   * RENDER
   * ========================= */

  render() {
    const {
      cHtml,
      rcmpFilter,
      bIsItToInsertGoBackBtn,
      fnGoBack,
      router,
      rcmpOptionMenu,
      windowHistory,
    } = this.props;

    const { navigate } = router || { navigate: () => {} };

    return (
      <div className="card-header v2-page-cardheader">
        {bIsItToInsertGoBackBtn && (
          <div
            className="v2-page-btn-goback"
            onClick={evtClick => {
              // prioridade: histórico do browser
              if (windowHistory) {
                window.history.back();
                return;
              }

              // comportamento padrão com stack
              if (fnGoBack === null && navigate) {
                this.popAndGoBack(navigate);
                return;
              }

              // callback customizado
              if (fnGoBack !== null) {
                fnGoBack(evtClick);
              }
            }}
          >
            <img src={imgfSelectLeft} alt="" />
          </div>
        )}

        {cHtml}
        {this.renderButtons()}
        {rcmpFilter}
        {rcmpOptionMenu}
      </div>
    );
  }
}

CardHeader.defaultProps = {
  bIsItToInsertGoBackBtn: true,
  fnGoBack: null,
  rcmpOptionMenu: null,
};

export default withRouter(CardHeader);
